
const slideshow = require('./component/slideshow');
const cart      = require('./component/buy');


slideshow.onDraw(function(response, card){
  card.find('.card-title').attr('data-id', response.id);
});

slideshow.onResponse(function(response) {
  slide.rebindTiles();
});

var slide = {

  load: function(card) {
    const id = card.find('.card-title').data('id');
    slide.position = card.closest("#slide-new-products").length ? card.index()-1 : card.index();

    $('.modal-preview').data('current', '#'+card.closest('.slideshow-content').attr('id')).modal('show').find('.modal-body').html(
      $('<div>').addClass('row h-100 align-items-center').append(
        $('<div>').addClass('col-12 text-center').append(
          $('<i>').addClass('fa fa-spinner fa-pulse fa-2x')
        )
      )
    );

    $.ajax({
      url: `${$('html').attr('lang')}/product`,
      type: 'POST',
      data: {id: id},
    })
    .done(function(response) {

      $('.modal-preview .modal-body').html(response)
      $('.input-group input, .input-group button, .input-group select').unbind('focusin focusout').focusin(function(){
        $(this).closest('.input-group').addClass('active');
      }).focusout(function(){
        $(this).closest('.input-group').removeClass('active');
      });
      
      cart.render();
      
    });
    

  },

  rebindTiles: function() {
    $('.slideshow-content .card .slideshow-part-num-link, .slideshow-content .card .slideshow-img-link').unbind('click').bind('click', function(event) {
      event.preventDefault();

      slide.load($(this).closest('.slideshow-card'))

    });

  },

  init: function() {
    $('.modal-nav').click(function(event) {
      
      const step   = $(this).hasClass('nav-minus') ? -1 : 1;
      const length = $(`${$('.modal-preview').data('current')} .slideshow-card`).length - 1;
      slide.position += step;
      slide.position = slide.position > length ? 0 : (slide.position < 0 ? length : slide.position);
      slide.load($(`${$('.modal-preview').data('current')} .slideshow-card`).eq(slide.position));

    });

    slide.rebindTiles();
  }
}

slide.init();